<template>
  <div class="warp">
    <!-- 头部搜索栏 -->
    <div>
      <div class="button" style="margin-bottom: 20px">
        <el-button type="primary" size="mini" @click="Adddialog">添加</el-button>
        <el-button type="success" size="mini" @click="next()">刷新</el-button>
        <el-button type="primary" size="mini" @click="select()">筛选</el-button>
        <!-- <el-popconfirm
          :hide-icon="true"
          title="确定删除选中项吗？"
          @onConfirm="delItem(choseItem, 'all')"
        >
          <el-button
            slot="reference"
            type="danger"
            size="mini"
            style="margin-left: 10px"
            >删除</el-button
          >
        </el-popconfirm> -->
      </div>

      <div class="head_search">
        <div class="item_warp">
          <label style="width: 94px">备注:</label>
          <el-input v-model="memo" placeholder="请输入备注" size="mini" clearable />
        </div>
        <div class="item_warp">
          <label style="width: 74px">key:</label>
          <el-input v-model="kiy" placeholder="请输入key" size="mini" clearable />
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="table_warp">
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="userTable"
        border
        style="width: 1351px"
        height="calc(100vh - 320px )"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="50" /> -->
        <!-- 备注 -->
        <el-table-column label="备注" width="300">
          <template slot-scope="scoped">
            <div style="text-align: left">
              {{ scoped.row.memo }}
            </div>
          </template>
        </el-table-column>
        <!-- key -->
        <el-table-column label="key" width="300">
          <template slot-scope="scoped">
            <div style="text-align: left">
              {{ scoped.row.kiy }}
            </div>
          </template>
        </el-table-column>
        <!-- value -->
        <el-table-column label="value" width="300">
          <template slot-scope="scoped">
            <div v-if="scoped.row.type == 'Integer'">
              {{ scoped.row.typeInteger }}
            </div>
            <div v-if="scoped.row.type == 'String'">
              {{ scoped.row.typeString }}
            </div>
            <div v-if="scoped.row.type == 'Long'">
              {{ scoped.row.typeLong }}
            </div>
            <div v-if="scoped.row.type == 'Boolean'">
              <div :class="[scoped.row.typeBoolean == true ? 'green' : 'red']">
                {{ scoped.row.typeBoolean == true ? '是' : '否' }}
              </div>
            </div>
            <div v-if="scoped.row.type == 'BigDecimal'">
              {{ scoped.row.typeBigDecimal.toFixed(2) }}
            </div>
            <div v-if="scoped.row.type == 'ListString'" style="max-height: 300px; overflow-y: auto">
              <div>
                <el-tag v-for="tag in scoped.row.typeListString" :key="tag" :disable-transitions="false">
                  {{ tag }}
                </el-tag>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- type -->
        <el-table-column prop="type" label="type" width="100" />
        <!-- 创建时间-->
        <el-table-column prop="createDate" label="创建时间" width="200" />
        <!-- 操作 -->
        <el-table-column prop="address" label="操作" width="150">
          <template slot-scope="scoped">
            <div class="flex-center">
              <el-button type="primary" size="mini" style="margin-right: 5px" @click="editDetails(scoped.row)">编辑</el-button>
              <el-popconfirm :hide-icon="true" title="确定删除这条动态吗？" @onConfirm="delItem(scoped.row, 'single')">
                <el-button slot="reference" type="danger" size="mini" style="margin-right: 10px">删除</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination v-show="total > 0" :total="total" :page.sync="pageNumber" :limit.sync="pageSize" :page-sizes="[2, 5, 10, 20, 50]" @pagination="next()" />
    <!-- 添加弹窗 -->
    <el-dialog :visible.sync="adddialog" width="50%" :close-on-click-modal="false" @close="addclose">
      <el-form ref="numberValidateForm" :model="addItem" size="mini" label-width="100px" class="demo-ruleForm">
        <!-- 备注 -->
        <el-form-item label="备注">
          <el-input v-model="addItem.memo" size="mini" style="width: 300px" />
        </el-form-item>
        <!-- key -->
        <el-form-item label="key:">
          <el-input v-model="addItem.kiy" size="mini" style="width: 300px" />
        </el-form-item>
        <el-form-item label="值:">
          <el-radio-group v-model="addItem.radio">
            <!-- Integer -->
            <div class="zhi">
              <el-radio
                :label="1"
              >Integer
                <el-input v-model="addItem.IntegerValue" size="mini" style="width: 300px" type="number" onkeyup="value=this.value.replace(/\D+/g,'')" />
              </el-radio>
            </div>
            <!-- String -->
            <div class="zhi">
              <el-radio
                :label="2"
              >String
                <el-input v-model="addItem.StringValue" size="mini" style="width: 300px" />
              </el-radio>
            </div>
            <!-- Long -->
            <div class="zhi">
              <el-radio
                :label="3"
              >Long
                <el-input v-model="addItem.LongValue" size="mini" style="width: 300px" type="number" onkeyup="value=this.value.replace(/\D+/g,'')" />
              </el-radio>
            </div>
            <!-- Boolean -->
            <div class="zhi" style="justify-content: left">
              <el-radio
                :label="4"
              >Boolean
                <el-checkbox v-model="addItem.BooleanValue" size="mini" style="margin-left: 20px">是</el-checkbox>
              </el-radio>
            </div>
            <!-- BigDecimal -->
            <div class="zhi">
              <el-radio
                :label="5"
              >BigDecimal
                <el-input
                  v-model="addItem.BigDecimalValue"
                  size="mini"
                  style="width: 300px"
                  type="number"
                  onkeyup="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                />
              </el-radio>
            </div>
            <!-- ListString -->
            <div class="zhi" style="justify-content: left; align-items: baseline">
              <el-radio :label="6">ListString</el-radio>
              <div>
                <el-tag v-for="tag in addItem.ListStringValue" :key="tag" closable :disable-transitions="false" @close="addhandleClose(tag)">
                  {{ tag }}
                </el-tag>
                <el-input
                  v-if="addinputVisible"
                  ref="addsaveTagInput"
                  v-model="addinputValue"
                  class="input-new-tag"
                  size="small"
                  @keyup.enter.native="addhandleInputConfirm"
                  @blur="addhandleInputConfirm"
                />
                <el-button v-else class="button-new-tag" size="small" @click="addshowInput">新增标签</el-button>
              </div>
            </div>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveNewParams()">提交</el-button>
      </span>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog :visible.sync="editdialog" width="50%" :close-on-click-modal="false" @close="edithandleClose">
      <el-form ref="numberValidateForm" :model="editItem" size="mini" label-width="100px" class="demo-ruleForm">
        <!-- 备注 -->
        <el-form-item label="备注">
          <el-input v-model="editItem.memo" size="mini" style="width: 300px" />
        </el-form-item>
        <!-- key -->
        <el-form-item label="key:">
          <el-input v-model="editItem.kiy" size="mini" style="width: 300px" />
        </el-form-item>
        <el-form-item label="值:">
          <el-radio-group v-model="editItem.radio">
            <!-- Integer -->
            <div class="zhi">
              <el-radio
                :label="1"
              >Integer
                <el-input v-model="editItem.IntegerValue" size="mini" style="width: 300px" type="number" onkeyup="value=this.value.replace(/\D+/g,'')" />
              </el-radio>
            </div>
            <!-- String -->
            <div class="zhi">
              <el-radio
                :label="2"
              >String
                <el-input v-model="editItem.StringValue" size="mini" style="width: 300px" />
              </el-radio>
            </div>
            <!-- Long -->
            <div class="zhi">
              <el-radio
                :label="3"
              >Long
                <el-input v-model="editItem.LongValue" size="mini" style="width: 300px" type="number" onkeyup="value=this.value.replace(/\D+/g,'')" />
              </el-radio>
            </div>
            <!-- Boolean -->
            <div class="zhi" style="justify-content: left">
              <el-radio
                :label="4"
              >Boolean
                <el-checkbox v-model="editItem.BooleanValue" size="mini" style="margin-left: 20px">是</el-checkbox>
              </el-radio>
            </div>
            <!-- BigDecimal -->
            <div class="zhi">
              <el-radio
                :label="5"
              >BigDecimal
                <el-input
                  v-model="editItem.BigDecimalValue"
                  size="mini"
                  style="width: 300px"
                  type="number"
                  onkeyup="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                />
              </el-radio>
            </div>
            <!-- ListString -->
            <div class="zhi" style="justify-content: left; align-items: baseline">
              <el-radio :label="6">ListString </el-radio>
              <div style="display: flex; flex-wrap: wrap; align-items: baseline">
                <el-tag
                  v-for="tag in editItem.ListStringValue"
                  :key="tag"
                  closable
                  :disable-transitions="false"
                  @click="changeValue(tag)"
                  @close="handleClose(tag)"
                >
                  {{ tag }}
                </el-tag>
              </div>
            </div>
          </el-radio-group>
        </el-form-item>
        <div style="text-align: center">
          <el-input
            v-if="inputVisible"
            ref="saveTagInput"
            v-model="inputValue"
            class="input-new-tag"
            type="textarea"
            size="small"
            style="width: 300px"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          />
          <el-button v-else class="button-new-tag" size="small" @click="showInput">新增标签</el-button>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="update()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination' // 引入分页器
// import uploadPic from '@/components/Upload/UploadPic' // 引入单图片上传组件
import environment from '@/utils/environment'

export default {
  name: 'GlobalNewParams',
  components: { Pagination },
  data() {
    return {
      // 商品分页信息
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      type: '',
      editType: '',
      editId: '',
      memo: '',
      kiy: '',
      loading: false, // 表格加载
      userTable: [],
      choseItem: [], // 选中项
      addinputVisible: false,
      addinputValue: '',
      inputVisible: false,
      inputValue: '',
      adddialog: false, // 添加弹窗标识
      editdialog: false, // 编辑弹窗标识
      addItem: {
        memo: '',
        kiy: '',
        radio: 0,
        IntegerValue: '',
        StringValue: '',
        LongValue: '',
        BooleanValue: false,
        BigDecimalValue: '',
        ListStringValue: []
      },
      editItem: {
        memo: '',
        kiy: '',
        radio: 0,
        IntegerValue: '',
        StringValue: '',
        LongValue: '',
        BooleanValue: false,
        BigDecimalValue: '',
        ListStringValue: []
      },
      tempTag: '',
      isChange: false
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList() {
      var params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        kiy: this.kiy,
        memo: this.memo
      }
      this.$api.config
        .getList(params)
        .then(res => {
          console.log(res)
          this.userTable = res.records
          this.pageNumber = res.current
          this.pageSize = res.size
          this.total = res.total
        })
        .catch(err => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {})
    },
    // 打开添加商品弹窗
    Adddialog() {
      this.adddialog = true
      this.addItem = {
        memo: '',
        kiy: '',
        radio: 0,
        IntegerValue: '',
        StringValue: '',
        LongValue: '',
        BooleanValue: false,
        BigDecimalValue: '',
        ListStringValue: []
      }
      this.adddialog = true
    },
    // 添加弹窗点击新增标签出现input框
    addshowInput() {
      this.addinputVisible = true
      this.$nextTick(_ => {
        this.$refs.addsaveTagInput.$refs.input.focus()
      })
    },
    // 添加弹窗确认输入内容后触发
    addhandleInputConfirm() {
      const addinputValue = this.addinputValue
      if (addinputValue) {
        this.addItem.ListStringValue.push(addinputValue)
      }
      this.addinputVisible = false
      this.addinputValue = ''
    },
    // 添加弹窗删除内容后触发
    addhandleClose(tag) {
      this.addItem.ListStringValue.splice(this.addItem.ListStringValue.indexOf(tag), 1)
    },
    // 编辑弹窗点击新增标签出现input框
    showInput() {
      this.inputVisible = true
      this.inputValue = ''
      this.isChange = false
      this.$nextTick(_ => {
        this.$refs.saveTagInput.focus()
      })
    },
    // 编辑弹窗确认输入内容后触发
    handleInputConfirm() {
      const inputValue = this.inputValue
      // 判断是否修改原有值，是 替换修改好的值，否新增
      if (this.isChange) {
        this.editItem.ListStringValue[this.editItem.ListStringValue.indexOf(this.tempTag)] = this.inputValue
        this.inputVisible = false
        return
      }
      if (inputValue) {
        this.editItem.ListStringValue.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 删除编辑弹窗标签数据
    handleClose(tag) {
      this.editItem.ListStringValue.splice(this.editItem.ListStringValue.indexOf(tag), 1)
    },
    // 选中
    handleSelectionChange(e) {
      this.choseItem = e
    },
    // 关闭添加弹窗
    addclose() {
      this.addItem = {
        memo: '',
        kiy: '',
        radio: 0,
        IntegerValue: '',
        StringValue: '',
        LongValue: '',
        BooleanValue: false,
        BigDecimalValue: '',
        ListStringValue: []
      }
    },
    // 关闭编辑弹窗
    edithandleClose() {
      this.editItem = {
        memo: '',
        kiy: '',
        radio: 0,
        IntegerValue: '',
        StringValue: '',
        LongValue: '',
        BooleanValue: false,
        BigDecimalValue: '',
        ListStringValue: []
      }
      this.tempTag = ''
      this.inputVisible = false
      this.isChange = false
    },
    // 删除商品
    delItem(items, type) {
      var postContentIds = []
      if (type == 'all') {
        if (items.length == 0) {
          return this.$message.error('您还没选中任何一条动态')
        }
        items.forEach(item => {
          postContentIds.push(item.id)
        })
      } else if (type == 'single') {
        postContentIds.push(items.id)
      }
      var params = {
        //   ids是数组
        ids: postContentIds.toString()
      }
      this.$api.config
        .deleteNewParams(params)
        .then(res => {
          this.$message.success(res)
          this.getList()
        })
        .catch(err => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 下一页或刷新
    next() {
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      this.getList()
    },
    select() {
      this.pageNumber = 1
      this.getList()
    },
    // 添加新全局参数
    saveNewParams() {
      switch (this.addItem.radio) {
        case 1:
          this.type = 'Integer'
          break
        case 2:
          this.type = 'String'
          break
        case 3:
          this.type = 'Long'
          break
        case 4:
          this.type = 'Boolean'
          break
        case 5:
          this.type = 'BigDecimal'
          break
        case 6:
          this.type = 'ListString'
          break
      }
      if (!this.addItem.radio) {
        return this.$message.error('请选择单选框,并在相应的输入框填写数据')
      }
      if (!this.addItem.memo) {
        return this.$message.error('请填写备注')
      }
      if (!this.addItem.kiy) {
        return this.$message.error('请填写key')
      }
      const params = {
        memo: this.addItem.memo,
        kiy: this.addItem.kiy,
        type: this.type,
        typeInteger: this.addItem.IntegerValue && this.type == 'Integer' ? this.addItem.IntegerValue : '',
        typeString: this.addItem.StringValue && this.type == 'String' ? this.addItem.StringValue : '',
        typeLong: this.addItem.LongValue && this.type == 'Long' ? this.addItem.LongValue : '',
        typeBoolean: this.addItem.BooleanValue && this.type == 'Boolean' ? this.addItem.BooleanValue : false,
        typeBigDecimal: this.addItem.BigDecimalValue && this.type == 'BigDecimal' ? this.addItem.BigDecimalValue : '',
        typeListString: this.addItem.ListStringValue && this.type == 'ListString' ? this.addItem.ListStringValue : []
      }
      this.$api.config
        .saveNewParams(params)
        .then(res => {
          this.adddialog = false
          this.$message.success(res)
          this.getList()
        })
        .catch(err => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    // 打开编辑弹窗
    editDetails(row) {
      console.log(row)
      if (row.type == 'Integer') {
        this.editItem.radio = 1
        row.typeString = ''
        row.typeLong = ''
        row.typeBoolean = false
        row.typeBigDecimal = ''
        row.typeListString = []
        this.editType = 'Integer'
      } else if (row.type == 'String') {
        this.editItem.radio = 2
        row.typeInteger = ''
        row.typeLong = ''
        row.typeBoolean = false
        row.typeBigDecimal = ''
        row.typeListString = []
        this.editType = 'String'
      } else if (row.type == 'Long') {
        this.editItem.radio = 3
        row.typeInteger = ''
        row.typeString = ''
        row.typeBoolean = false
        row.typeBigDecimal = ''
        row.typeListString = []
        this.editType = 'Long'
      } else if (row.type == 'Boolean') {
        this.editItem.radio = 4
        row.typeInteger = ''
        row.typeString = ''
        row.typeLong = ''
        row.typeBigDecimal = ''
        row.typeListString = []
        this.editType = 'Boolean'
      } else if (row.type == 'BigDecimal') {
        this.editItem.radio = 5
        row.typeInteger = ''
        row.typeString = ''
        row.typeLong = ''
        row.typeBoolean = false
        row.typeListString = []
        this.editType = 'BigDecimal'
      } else if (row.type == 'ListString') {
        this.editItem.radio = 6
        row.typeInteger = ''
        row.typeString = ''
        row.typeLong = ''
        row.typeBoolean = false
        row.typeBigDecimal = ''
        this.editType = 'ListString'
      }
      this.editId = row.id
      this.editItem.memo = row.memo
      this.editItem.kiy = row.kiy
      this.editItem.IntegerValue = row.typeInteger ? row.typeInteger : ''
      this.editItem.StringValue = row.typeString ? row.typeString : ''
      this.editItem.LongValue = row.typeLong ? row.typeLong : ''
      this.editItem.BooleanValue = row.typeBoolean
      this.editItem.BigDecimalValue = row.typeBigDecimal ? row.typeBigDecimal : ''
      this.editItem.ListStringValue = JSON.parse(JSON.stringify(row.typeListString)) ? JSON.parse(JSON.stringify(row.typeListString)) : []
      this.editdialog = true
    },
    // 编辑
    update() {
      if (!this.editItem.radio) {
        return this.$message.error('请选择单选框,并在相应的输入框填写数据')
      }
      if (!this.editItem.memo) {
        return this.$message.error('请填写备注')
      }
      if (!this.editItem.kiy) {
        return this.$message.error('请填写key')
      }
      switch (this.editItem.radio) {
        case 1:
          this.editType = 'Integer'
          this.editItem.StringValue = ''
          this.editItem.LongValue = ''
          this.editItem.BooleanValue = false
          this.editItem.BigDecimalValue = ''
          this.editItem.ListStringValue = []
          break
        case 2:
          this.editType = 'String'
          this.editItem.IntegerValue = ''
          this.editItem.LongValue = ''
          this.editItem.BooleanValue = false
          this.editItem.BigDecimalValue = ''
          this.editItem.ListStringValue = []
          break
        case 3:
          this.editType = 'Long'
          this.editItem.IntegerValue = ''
          this.editItem.StringValue = ''
          this.editItem.BooleanValue = false
          this.editItem.BigDecimalValue = ''
          this.editItem.ListStringValue = []
          break
        case 4:
          this.editType = 'Boolean'
          this.editItem.IntegerValue = ''
          this.editItem.StringValue = ''
          this.editItem.LongValue = ''
          this.editItem.BigDecimalValue = ''
          this.editItem.ListStringValue = []
          break
        case 5:
          this.editType = 'BigDecimal'
          this.editItem.IntegerValue = ''
          this.editItem.StringValue = ''
          this.editItem.LongValue = ''
          this.editItem.BooleanValue = false
          this.editItem.ListStringValue = []
          break
        case 6:
          this.editType = 'ListString'
          this.editItem.IntegerValue = ''
          this.editItem.StringValue = ''
          this.editItem.LongValue = ''
          this.editItem.BooleanValue = false
          this.editItem.BigDecimalValue = ''
          break
      }
      const params = {
        memo: this.editItem.memo,
        kiy: this.editItem.kiy,
        id: this.editId,
        type: this.editType,
        typeInteger: this.editItem.IntegerValue && this.editType == 'Integer' ? this.editItem.IntegerValue : '',
        typeString: this.editItem.StringValue && this.editType == 'String' ? this.editItem.StringValue : '',
        typeLong: this.editItem.LongValue && this.editType == 'Long' ? this.editItem.LongValue : '',
        typeBoolean: this.editItem.BooleanValue,
        typeBigDecimal: this.editItem.BigDecimalValue && this.editType == 'BigDecimal' ? this.editItem.BigDecimalValue : '',
        typeListString: this.editItem.ListStringValue && this.editType == 'ListString' ? this.editItem.ListStringValue : []
      }
      console.log(params)
      this.$api.config
        .updateNewParams(params)
        .then(res => {
          this.$message.success(res)
          this.editdialog = false
          this.getList()
        })
        .catch(err => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
    changeValue(tag) {
      this.inputVisible = true
      this.inputValue = tag
      this.tempTag = tag
      this.isChange = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.focus()
      })
    }
  }
}
</script>
<style lang="scss">
.el-image {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.head_search {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  .item_warp {
    display: flex;
    .el-checkbox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }
    label {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #525252;
      font-weight: 400;
    }
  }
}
.green {
  color: #00c759;
}
.red {
  color: rgb(255, 62, 51);
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  margin-top: 5px;
  height: 25px;
  line-height: 25px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.zhi {
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
}
.el-tag--mini {
  height: 20px;
  padding: 0px 5px;
  line-height: 19px;
  margin: 2px 0;
}
</style>
